import { API_URL_AWARD } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const deleteAward = (uuid: string) =>
  apiInstance({
    url: API_URL_AWARD + uuid,
    method: "delete",
  });

export default deleteAward;
